import React from "react";
import { useSelector } from "react-redux";
import ConfirmOverlay from "./ConfirmOverlay";
import MindsetOverlay from "./Mindset";

import SubscribeOverlay from "./SubscribeOverlay";
import MessagesOverlay from "./Messages/MessagesOverlay";

const Overlay = () => {
  const { visible, overlayType, overlayMode, ...rest } = useSelector(
    (state) => state.overlay,
  );

  return (
    <div
      className={`overlay animate__animated animate__fadeIn  animate__fast${visible ? " overlay--visible" : ""}${visible ? ` overlay--${overlayType}` : ""}`}
    >
      {visible && (
        <>
          {overlayType === "confirm" && <ConfirmOverlay {...rest} />}
          {overlayType === "mindset" && <MindsetOverlay />}
          {overlayType === "subscribe" && <SubscribeOverlay />}
          {overlayType === "messages" && <MessagesOverlay />}
        </>
      )}
    </div>
  );
};

export default Overlay;
